<template>
	<Row class="current-version-container flex-align-center">{{ keepNoun ? 'Version ' : '' }}{{ versionNumber }}</Row>
</template>
<script>
export default {
	name: 'WorkflowVersionIndication',
	props: { versionNumber: { type: Number, required: true }, keepNoun: { type: Boolean, default: true } },
};
</script>
<style scoped lang="scss">
.current-version-container {
	height: 22px;
	width: max-content;
	border-radius: 6px;
	background: #f5f7fa;
	border: 1px solid #d6ddea;

	font-size: 11px;
	font-weight: 300;
	color: #000000;
	line-height: 13px;
	letter-spacing: 0px;

	padding: 0px 4px;

	align-items: center;
}
</style>
